/* @generated */

// ../src/aspect_ratio/aspect-ratio.tsx
import * as React from "react";
import cx from "classnames";

// ../src/aspect_ratio/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var aspectRatioMaxHeightVar = "var(--dig-65qxdn3_22-5-0)";
var aspectRatioMinHeightVar = "var(--dig-65qxdn2_22-5-0)";
var aspectRatioRecipe = _7a468({ defaultClassName: "dig-65qxdn4_22-5-0", variantClassNames: { objectFit: { true: "dig-65qxdn5_22-5-0" }, minOrMaxHeight: { true: "dig-65qxdn6_22-5-0" } }, defaultVariants: {}, compoundVariants: [] });
var aspectRatioVar = "var(--dig-65qxdn0_22-5-0)";
var objectFitVar = "var(--dig-65qxdn1_22-5-0)";

// ../src/aspect_ratio/aspect-ratio.tsx
import { assignInlineVars } from "@vanilla-extract/dynamic";
var SVG_RATIOS = {
  contain: "xMidYMid meet",
  cover: "xMidYMid slice",
  none: void 0
};
var svgAspectRatioDecider = (objectFit) => {
  return SVG_RATIOS[objectFit];
};
var AspectRatio = ({
  children,
  ratio = 1,
  objectFit = "cover",
  minHeight: _minHeight,
  maxHeight: _maxHeight,
  className,
  style,
  ...rest
}) => {
  if (ratio <= 0) throw new TypeError("The ratio prop must result in a number greater than 0");
  const minHeight = typeof _minHeight === "number" ? `${_minHeight}px` : _minHeight;
  const maxHeight = typeof _maxHeight === "number" ? `${_maxHeight}px` : _maxHeight;
  const inlineVars = {
    [objectFitVar]: objectFit
  };
  if (minHeight) {
    inlineVars[aspectRatioMinHeightVar] = minHeight;
  }
  if (maxHeight) {
    inlineVars[aspectRatioMaxHeightVar] = maxHeight;
  }
  if (ratio) {
    inlineVars[aspectRatioVar] = `(${ratio})`;
  }
  const inlineStyle = {
    ...style,
    ...assignInlineVars({
      ...inlineVars
    })
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(
        "dig-AspectRatio",
        aspectRatioRecipe({ objectFit: !!objectFit, minOrMaxHeight: !!(minHeight || maxHeight) }),
        className
      ),
      style: inlineStyle,
      "data-testid": "DigAspectRatio",
      ...rest
    },
    typeof children === "function" ? children({ preserveAspectRatio: svgAspectRatioDecider(objectFit) }) : children
  );
};
AspectRatio.displayName = "AspectRatio";
export {
  AspectRatio
};
